import "core-js/modules/es.number.constructor";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-dataV-activeRing",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  watch: {
    'option.attribute': {
      handler: function handler() {
        this.loadData();
      },
      deep: true //深度监听

    },
    width: function width() {
      this.refreshFlagKey = require('uuid').v1();
    },
    height: function height() {
      this.refreshFlagKey = require('uuid').v1();
    }
  },
  data: function data() {
    return {
      uuid: null,
      config: {},
      refreshFlagKey: null
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
      this.refreshFlagKey = require('uuid').v1();
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, 'ActiveRing').then(function (res) {
        _this.config = JSON.parse(JSON.stringify(_this.option.attribute));
        _this.config.data = res;
      });
    }
  }
};